import { motion } from 'framer-motion';
import { cases } from '../data';
import { ExternalLink, Download } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SocialProof() {
  const mainCase = cases[0];

  return (
    <section className="bg-[#103B66] text-white overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[600px]">
        {/* Text Content */}
        <div className="lg:w-1/2 flex items-center py-16 lg:py-24 px-6 sm:px-12 lg:pl-24 lg:pr-16 xl:pl-32 order-2 lg:order-1">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="max-w-xl"
          >
            <span className="text-slate-300 font-bold tracking-wider uppercase text-sm mb-4 block">
              Erfaring fra virkeligheden
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight">
              {mainCase.title}
            </h2>
            <p className="text-xl text-slate-100 mb-10 leading-relaxed">
              {mainCase.description}
            </p>
            <a
              href="https://www.sn.dk/art6436652/koege-kommune/nyhed/86-aarig-tog-fusen-paa-falske-bankmaend-nu-er-formodede-storsvindlere-faengslet/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-white text-[#103B66] font-bold hover:bg-slate-50 transition-all"
            >
              {mainCase.cta}
              <ExternalLink className="ml-2 w-4 h-4" />
            </a>
          </motion.div>
        </div>

        {/* Image Content - Full Bleed */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="lg:w-1/2 h-[400px] lg:h-auto order-1 lg:order-2 relative group"
        >
          <img 
            src={mainCase.image} 
            alt={mainCase.title}
            className="w-full h-full object-cover"
          />
          <a
            href={mainCase.image}
            download="86-aarig-tog-fusen-paa-falske-bankmaend.jpg"
            target="_blank"
            rel="noopener noreferrer"
            onClick={async (e) => {
              e.preventDefault();
              try {
                const response = await fetch(mainCase.image);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = '86-aarig-tog-fusen-paa-falske-bankmaend.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              } catch {
                window.open(mainCase.image, '_blank');
              }
            }}
            className="absolute bottom-4 right-4 bg-slate-900/80 hover:bg-slate-900 text-white text-xs font-semibold px-3 py-2 rounded shadow-md backdrop-blur-sm transition-all flex items-center gap-2 opacity-90 group-hover:opacity-100"
            title="Download billede"
          >
            <Download className="w-4 h-4" />
            <span>Download billede</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
